<div class="loader-overlay" *ngIf="isLoading">
    <i class="fa-solid fa-spinner fa-spin" style="font-size: 48px; color: #4A90E2;"></i>
</div>
